import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPortuguese = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_198_10516)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M0 8.00045C0 11.4401 2.171 14.3725 5.21734 15.5028L5.91303 8.00042L5.21734 0.498047C2.171 1.62842 0 4.56073 0 8.00045Z",
					fill: "#6DA544"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M16.0004 8C16.0004 3.58175 12.4187 0 8.00043 0C7.02187 0 6.08446 0.176031 5.21777 0.497594V15.5024C6.08446 15.824 7.02187 16 8.00043 16C12.4187 16 16.0004 12.4183 16.0004 8Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M5.21716 10.783C6.75395 10.783 7.99976 9.53715 7.99976 8.00037C7.99976 6.46358 6.75395 5.21777 5.21716 5.21777C3.68038 5.21777 2.43457 6.46358 2.43457 8.00037C2.43457 9.53715 3.68038 10.783 5.21716 10.783Z",
					fill: "#FFDA44"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M3.65234 6.6084V8.34752C3.65234 9.21196 4.35309 9.91274 5.21756 9.91274C6.08203 9.91274 6.78278 9.21199 6.78278 8.34752V6.6084H3.65234Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M5.21706 8.86972C4.92937 8.86972 4.69531 8.63566 4.69531 8.34797V7.65234H5.73878V8.348C5.73878 8.63566 5.50472 8.86972 5.21706 8.86972Z",
					fill: "white"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_198_10516",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 16,
				height: 16,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgPortuguese);
export { ForwardRef as ReactComponent };
